import { render } from "./PrivacyModal.vue?vue&type=template&id=f1d5ca36&scoped=true"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"

import "./PrivacyModal.vue?vue&type=style&index=0&id=f1d5ca36&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d5ca36"]])

export default __exports__